import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
@Component({
})
export default class ScheduleList extends Vue {
    //
    // ────────────────────────────────────────────────── I ──────────
    //   :::::: P R O P S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────
    //

    @Prop({ type: Array, default: [] }) items!: []

    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: M E T H O D S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //

    goDetail(item: calendar.CalendarItem) {
        this.$router.push({
            name: 'calendar-read',
            query: { itemid: item.id }
        })
    }
}